let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3vCNW")).then(() => parcelRequire('5OEnJ'));